export default __webpack_public_path__ + "static/media/Dice-8.85b5ac15.png";